import React, { useEffect, useState } from 'react';
import {
  GetCompanyWiseInventoryData,
  GetProductWiseinventoryData,
} from '../../screen/distributor/action/util_action';
import {
  Box,
  CircularProgress,
  Drawer,
  Grid,
  IconButton,
  Tabs,
  Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { unitCaseEnum } from '../../utils/settings';
import { FilterList } from '@mui/icons-material';
import ProductCard from './components/ProductCard';
import CartBadge from './components/CartBadge';
import { fetchSkuFilterAction } from '../../v2/APIs/action';
import CustomTab from '../../v2/MUI_custom_component/Tab/CustomTab';
import { trackAnalyticsEvent } from '../../utils/clevertap/clevertapUtils';
import IllustrationWrapper from '../Illustrration/IllustrationWrapper';
import NoInventorySvg from '../Illustrration/components/NoInventorySvg';
import { FilterComponent } from '../Common/FilterComponent';

const CompanyWiseInventory = () => {
  const dispatch = useDispatch();


  const { cartItemList, alignmentValue } = useSelector((state) => ({
    cartItemList: state.fmcgReducer.cartItemList,
    alignmentValue: state.fmcgReducer.alignmentValue,
  }));

  const {
    selectedSupplier: company_id,
    selectedEntity: company_esi_id,
  } = useSelector((state) => state.entityReducer);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [selectedCompanyData, setSelectedCompanyData] = useState({});
  const [products, setProducts] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  // const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedFiltersList, setSelectedFiltersList] = useState([]);

  // Wrapper function to track filter changes
  const handleFilterChange = (newFilters) => {
    const oldFilters = selectedFiltersList;
    setSelectedFiltersList(newFilters);

    // Track filter application
    trackAnalyticsEvent('INVENTORY_FILTERS_APPLIED', {
      screen_name: 'company_wise_inventory',
      company_id: selectedCompany,
      previous_filters: oldFilters.join(','),
      new_filters: newFilters.join(','),
      previous_filters_count: oldFilters.length,
      new_filters_count: newFilters.length,
      filters_added: newFilters.length > oldFilters.length,
      filters_removed: newFilters.length < oldFilters.length,
      action: 'filters_changed'
    });
  };
  const [toggleButtonlist, setToggleButtonList] = useState([]);
  const [alignment, setAlignment] = useState(alignmentValue);
  const [inventoryMessage, setInventoryMessage] = useState(null);
  const [filters, setFilters] = useState([]);
  const [isFiltersModalOpen, setIsFiltersModalOpen] = useState(false);

  const toggleFilterDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) return;
    
    if (!open) {
      // Track filter drawer close
      trackAnalyticsEvent('INVENTORY_FILTER_CLOSED', {
        screen_name: 'company_wise_inventory',
        company_id: selectedCompany,
        current_filters: selectedFiltersList.join(','),
        filters_count: selectedFiltersList.length,
        action: 'filter_drawer_close'
      });
    }
    
    setIsFiltersModalOpen(open);
  };

  const getCompanyWiseInventory = async () => {
    setIsLoading(true);

    // Track company inventory page load
    trackAnalyticsEvent('COMPANY_INVENTORY_PAGE_LOADED', {
      screen_name: 'company_wise_inventory',
      company_id: company_id,
      action: 'page_load'
    });

    const { error, data } = await GetCompanyWiseInventoryData(company_esi_id);
    setIsLoading(false);

    if (!error) {
      let index = data.findIndex((ele) => ele.company_id == company_id);
      if (index === -1) index = 0;

      const selected = data[index];
      setSelectedCompany(selected?.company_id);
      setSelectedCompanyData(selected);

      const toggleList = [
        { value: 0, label: selected?.allocable_quantity?.unit },
        { value: 1, label: selected?.allocable_quantity?.base_unit },
      ];
      if (alignmentValue === undefined || alignmentValue === null) {
        setAlignment(toggleList[1]?.value);
      }
      
      if (selected?.allocable_quantity?.unit && selected?.allocable_quantity?.base_unit) {
        setToggleButtonList(toggleList);
      }
      dispatch({ type: 'SET_SELLER_ID', data: selected?.company_id });

      // Track successful company inventory load
      trackAnalyticsEvent('COMPANY_INVENTORY_DATA_LOADED', {
        screen_name: 'company_wise_inventory',
        company_id: selected?.company_id,
        company_name: selected?.company_name,
        has_toggle_options: toggleList.length > 0,
        available_quantity: selected?.allocable_quantity?.quantity_in_metric_ton,
        blocked_quantity: selected?.blocked_quantity?.quantity_in_metric_ton
      });
    } else {
      toast.error('Error fetching company inventory data');
      // Track failed inventory load
      trackAnalyticsEvent('COMPANY_INVENTORY_DATA_LOAD_FAILED', {
        screen_name: 'company_wise_inventory',
        company_id: company_id,
        error_message: 'Error fetching company inventory data'
      });
    }
  };

  const getProductInventory = async () => {
    setIsLoading(true);
    const { error, data } = await GetProductWiseinventoryData({
      company_esi_id: company_esi_id,
      manufacturer_id: company_id,
      product_filters: selectedFiltersList.join('~'),
    });
    setIsLoading(false);

    if (!error) {
      if (data.length > 0) {
        setProducts(data[0].inventory_list);
        setInventoryMessage(data[0].message);

        // Track successful product load
        trackAnalyticsEvent('PRODUCT_INVENTORY_DATA_LOADED', {
          screen_name: 'company_wise_inventory',
          company_id: company_id,
          products_count: data[0].inventory_list.length,
          filters_applied: selectedFiltersList.length > 0,
          applied_filters: selectedFiltersList.join(','),
          message: data[0].message
        });
      } else {
        setProducts([]);
        selectedFiltersList.length > 0
          ? toast.error('No Inventory found for selected filters')
          : toast.error('No Inventory found for selected company');

        // Track no products found
        trackAnalyticsEvent('PRODUCT_INVENTORY_NO_DATA', {
          screen_name: 'company_wise_inventory',
          company_id: company_id,
          filters_applied: selectedFiltersList.length > 0,
          applied_filters: selectedFiltersList.join(','),
          reason: selectedFiltersList.length > 0 ? 'filters_no_match' : 'no_inventory'
        });
      }
    } else {
      toast.error(error);
      // Track product load error
      trackAnalyticsEvent('PRODUCT_INVENTORY_LOAD_FAILED', {
        screen_name: 'company_wise_inventory',
        company_id: company_id,
        error_message: error,
        filters_applied: selectedFiltersList.length > 0
      });
    }
  };

  const getFilters = async () => {
    const params = {
      query: {
        term: {
          company_id: selectedCompany || selectedCompanyData?.company_id,
        },
      },
      size: 500,
    };
    const { data, error } = await fetchSkuFilterAction('sku-master', params);

    if (!error) {
      setFilters(data.category_filters);
    }
  };

  const handleAlignment = (event, newAlignment) => {
    if (newAlignment !== null) {
      const previousAlignment = alignment;
      dispatch({ type: 'CLEAR_CART' });
      dispatch({
        type: 'FMCG_UNIT_CASE_WISE',
        data: !newAlignment ? unitCaseEnum['CASE'] : unitCaseEnum['UNIT'],
      });
      dispatch({
        type: 'SET_ALIGNMENT_VALUE',
        data: newAlignment,
      });
      setAlignment(newAlignment);

      // Track unit toggle change
      trackAnalyticsEvent('INVENTORY_UNIT_TOGGLE_CHANGED', {
        screen_name: 'company_wise_inventory',
        company_id: selectedCompany,
        previous_unit: previousAlignment === 0 ? 'cases' : 'units',
        new_unit: newAlignment === 0 ? 'cases' : 'units',
        previous_alignment: previousAlignment,
        new_alignment: newAlignment,
        action: 'unit_toggle'
      });
    }
  };

  const updateProdQty = ({ type, data, inputValue = null }) => {
    // Track quantity update action
    trackAnalyticsEvent('INVENTORY_PRODUCT_QUANTITY_UPDATED', {
      screen_name: 'company_wise_inventory',
      company_id: selectedCompany,
      product_id: data?.product_info?.product_id,
      product_name: data?.product_info?.product_name,
      action_type: type,
      input_value: inputValue,
      current_alignment: alignment === 0 ? 'cases' : 'units',
      available_quantity: data?.allocable_quantity?.quantity_in_metric_ton
    });

    dispatch({
      type: 'UPDATE_PROD_QTY',
      data: { type, data, inputValue },
    });
  };

  const getQuantityInCasesUnit = (
    quantity_in_metric_ton,
    quantity_in_bags,
    multiplier,
    is_inventory_homogeneous,
    unit,
    base_unit
  ) => {
    if (is_inventory_homogeneous) return quantity_in_metric_ton;
    const cases = Math.floor(quantity_in_bags / multiplier);
    const units = quantity_in_bags % multiplier;
    return `${cases} ${unit} & ${units} ${base_unit}`;
  };

  const showPriceColumn =
    !selectedCompanyData?.is_inventory_homogeneous &&
    products.some((row) => Number(row?.price_info?.mrp) > 0);


  useEffect(() => {
    getCompanyWiseInventory();
    
    // Only set UNIT if alignment value is not already set in Redux
    if (alignmentValue === undefined || alignmentValue === null) {
      dispatch({ type: 'FMCG_UNIT_CASE_WISE', data: unitCaseEnum['UNIT'] });
    }
  }, []);

  useEffect(() => {
    if (alignmentValue !== undefined && alignmentValue !== null) {
      setAlignment(alignmentValue);
    }
  }, [alignmentValue]);

  useEffect(() => {
    if (selectedCompany) {
      getProductInventory();
      getFilters();
    }
  }, [selectedCompany, selectedFiltersList]);
  if (!company_id) {
    return (
      <Box p={4}>
        <Typography variant="h6" color="error">
          No company selected. Please go back and select a company.
        </Typography>
      </Box>
    );
  }
  return (
    <Box sx={{ position: 'relative', p: { xs: 2, sm: 4 } }}>
      <Grid container spacing={2} alignItems="center">
        {toggleButtonlist.length > 0 && (
          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Tabs
                value={alignment}
                onChange={handleAlignment}
                TabIndicatorProps={{ style: { display: 'none' } }}
              >
                {toggleButtonlist.map((btn) => (
                  <CustomTab
                    key={btn.value}
                    label={btn.label}
                    value={btn.value}
                    active={btn.value === alignment}
                    type="standard"
                    variant="primary"
                  />
                ))}
              </Tabs>
              <Box display="flex" alignItems="center">
                
                <IconButton 
                  onClick={() => {
                    // Track filter button click
                    trackAnalyticsEvent('INVENTORY_FILTER_OPENED', {
                      screen_name: 'company_wise_inventory',
                      company_id: selectedCompany,
                      current_filters: selectedFiltersList.join(','),
                      filters_count: selectedFiltersList.length,
                      action: 'filter_button_click'
                    });
                    setIsFiltersModalOpen(true);
                  }}
                  sx={{
                    borderRadius: 1,
                    '&:hover': {
                      borderRadius: 1,
                    },
                  }}
                >
                  <Typography variant="labelD" mr={1}>
                    Filter
                  </Typography>
                  <FilterList sx={{ color: '#333' }} />
                </IconButton>
                <CartBadge cartItemList={cartItemList} />
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>

      {isLoading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height={300}>
          <CircularProgress />
        </Box>
      ) : (
        <Box mt={2} display="flex" flexDirection="column" gap={2}>
          {products.length === 0 ? (
            <IllustrationWrapper 
              illustration={<NoInventorySvg />}
              titleVariant="h3"
              subtitleVariant="body1"
              illustrationProps={{
                width: 300,
                height: 300,
              }}
              title={
                selectedFiltersList.length > 0
                  ? ''
                  : 'Nothing to see here!'
              }
              subtitle={
                selectedFiltersList.length > 0
                  ? 'No Inventory found for selected Filter'
                  : inventoryMessage || 'No Inventory found'
              }
            />

          ) : (
            products.map((row, index) => {
              const itemInCart = cartItemList.find(
                (item) => item.product_info.product_id === row.product_info.product_id
              );

              const availableQtyDisplay = alignment
                ? `${row?.allocable_quantity?.quantity_in_bags} ${row?.allocable_quantity?.base_unit}`
                : getQuantityInCasesUnit(
                    row?.allocable_quantity?.quantity_in_metric_ton,
                    row?.allocable_quantity?.quantity_in_bags,
                    row?.allocable_quantity?.multiplier,
                    selectedCompanyData?.is_inventory_homogeneous,
                    row?.allocable_quantity?.unit,
                    row?.allocable_quantity?.base_unit
                  );

              const unverifiedQtyDisplay = alignment
                ? `${row?.blocked_quantity?.quantity_in_bags} ${row?.blocked_quantity?.base_unit}`
                : getQuantityInCasesUnit(
                    row?.blocked_quantity?.quantity_in_metric_ton,
                    row?.blocked_quantity?.quantity_in_bags,
                    row?.blocked_quantity?.multiplier,
                    selectedCompanyData?.is_inventory_homogeneous,
                    row?.blocked_quantity?.unit,
                    row?.blocked_quantity?.base_unit
                  );
                
                const expiryInfo = alignment
                  ? row?.product_info?.expiry_badge_bags || null
                  : row?.product_info?.expiry_badge_ton || null;

              return (
                <Box key={index} borderTop="1px solid #d9d9d9">
                  <ProductCard
                    productName={row?.product_info?.product_name || ''}
                    availableQty={availableQtyDisplay}
                    unverifiedQty={unverifiedQtyDisplay}
                    imageUrl={row?.product_info?.product_logo || ''}
                    quantity={itemInCart?.sellToBuyerQty?.qty || 0}
                    onQuantityChange={(newQuantity) => {
                      const currentQty = itemInCart?.sellToBuyerQty?.qty || 0;
                      const type = newQuantity < currentQty ? 'REMOVE' : 'ADD';
                      updateProdQty({ type, data: row, inputValue: newQuantity })
                    }}
                    badgeText={expiryInfo}
                    onIncreasePress={() => {
                      updateProdQty({ type: 'ADD', data: row });
                    }}
                    onReducePress={() => {
                      updateProdQty({
                        type: 'REMOVE',
                        data: row,
                      });
                    }}
                    onTextChange={(input) => {
                      updateProdQty({
                        type: 'ADD',
                        data: row,
                        inputValue: Number(input),
                      });
                    }}
                    showDeleteButton={false}
                    showQuantityControls={true}
                    companyName={selectedCompanyData?.company_name || ''}
                    price={showPriceColumn && row?.price_info?.mrp ? row.price_info.mrp : null}
                    row={row}
                  />
                  
                </Box>
              );
            })
          )}
        </Box>
      )}
      <Drawer anchor="right" open={isFiltersModalOpen} onClose={toggleFilterDrawer(false)}>
        <FilterComponent
          data={filters}
          selectedFiltersList={selectedFiltersList}
          setSelectedFiltersList={handleFilterChange}
          setIsFiltersModalOpen={setIsFiltersModalOpen}
        />
      </Drawer>
    </Box>
  );
};

export default CompanyWiseInventory;
